import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import React from 'react';
import { MdPersonAddAlt1 } from 'react-icons/md';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '80%',
    background: 'red',
    //height: "90vh",
  },
  input: {
    marginTop: '10px',
    width: '30%',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
}));

export function CreateInstitution(props) {
  const [nit, setNit] = React.useState('');
  const [name, setName] = React.useState('');
  const [fixedPhone, setFixedPhone] = React.useState('');
  const [mobilePhone, setMobilePhone] = React.useState('');
  const [city, setCity] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [genre, setGenre] = React.useState('');
  const [workingDay, setWorkingDay] = React.useState('');
  const [type, setType] = React.useState('');
  const [calendar, setCalendar] = React.useState('');
  const [coursesType, setCoursesType] = React.useState('');
  const [activitiesType, setActivitiesType] = React.useState('');
  const [state, setState] = React.useState('');
  const classes = useStyles();
  const navigate = useNavigate();

  const handleCreate = async () => {
    try {
      if (name && fixedPhone) {
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/institutions',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              NIT: nit,
              name,
              fixedPhone,
              mobilePhone,
              city,
              address,
              email,
              genre,
              workingDay,
              type,
              calendar,
              coursesType,
              activitiesType,
              state,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          navigate('/admin/institutions', { replace: true });
        } else {
          window.alert(
            'Hubo un error al intentar realizar esta acción, intente de nuevo'
          );
        }
        setNit('');
        setName('');
        setFixedPhone('');
        setMobilePhone('');
        setCity('');
        setAddress('');
        setEmail('');
        setGenre('');
        setWorkingDay('');
        setType('');
        setCalendar('');
        setCoursesType('');
        setActivitiesType('');
        setState('');
      } else {
        window.alert('Por favor ingrese los campos obligatorios');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrá crear una nueva
        institución a la plataforma, todos los campos son obligatorios, el
        diligenciar correctamente esta sección permitirá mantener una base de
        datos actualizada y completa.
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="NIT"
          variant="outlined"
          value={nit}
          onChange={(e) => setNit(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Teléfono fijo"
          variant="outlined"
          value={fixedPhone}
          onChange={(e) => setFixedPhone(e.target.value)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Teléfono movil"
          variant="outlined"
          value={mobilePhone}
          onChange={(e) => setMobilePhone(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Ciudad"
          variant="outlined"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Dirección"
          variant="outlined"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Correo electrónico"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type={'email'}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">Genero</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={genre}
            onChange={(e) => setGenre(e.target.value)}
            label="Genero"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="FEMENINO">Femenino</MenuItem>
            <MenuItem value="MASCULINO">Masculino</MenuItem>
            <MenuItem value="MIXTO">Mixto</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">
            Jornada
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={workingDay}
            onChange={(e) => setWorkingDay(e.target.value)}
            label="Jornada"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="Diurno unico">Diurno unico</MenuItem>
            <MenuItem value="Jornada unica">Jornada unica</MenuItem>
            <MenuItem value="Tarde unico">Tarde unico</MenuItem>
            <MenuItem value="Nocturno">Nocturno</MenuItem>
            <MenuItem value="Sabatino">Sabatino</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">Tipo</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={type}
            onChange={(e) => setType(e.target.value)}
            label="Tipo"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="PRIVADO">Privado</MenuItem>
            <MenuItem value="OFICIAL">Oficial</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">
            Calendario
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={calendar}
            onChange={(e) => setCalendar(e.target.value)}
            label="Calendario"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="Calendario A">Calendario A</MenuItem>
            <MenuItem value="Calendario B">Calendario B</MenuItem>
            <MenuItem value="Calendario C">Calendario C</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">
            Tipo de cursos
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={coursesType}
            onChange={(e) => setCoursesType(e.target.value)}
            label="Tipo de cursos"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="ALFABETICOS">Alfabeticos</MenuItem>
            <MenuItem value="NUMERICOS">Numericos</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
        }}
      >
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">
            Tipo de actividades
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={activitiesType}
            onChange={(e) => setActivitiesType(e.target.value)}
            label="Tipo de activiades"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="LINEALES">Lineales</MenuItem>
            <MenuItem value="FLEXIBLES">Flexibles</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">
            Estado inicial
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={state}
            onChange={(e) => setState(e.target.value)}
            label="Estado inicial"
          >
            <MenuItem value="" disabled>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="ACTIVO">Activo</MenuItem>
            <MenuItem value="INACTIVO">Inactivo</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-evenly',
          marginTop: '50px',
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            setNit('');
            setName('');
            setFixedPhone('');
            setMobilePhone('');
            setCity('');
            setAddress('');
            setEmail('');
            setGenre('');
            setWorkingDay('');
            setType('');
            setCalendar('');
            setCoursesType('');
            setActivitiesType('');
            setState('');
          }}
        >
          Limpiar
        </Button>
        <Button onClick={handleCreate} variant="contained" color="primary">
          <MdPersonAddAlt1 size={15} />
          Crear
        </Button>
      </div>
    </div>
  );
}
